import React from 'react';
import PropTypes from 'prop-types';
import { WmsLayer, provideMapState } from 'react-openlayers';
import Splitter from './Splitter';
import TimePicker from './Timepicker';
import './Layers.css';

class Layers extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      left: [
        {
          key: 'TIME',
          value: '2017-01'
        }
      ],
      right: [
        {
          key: 'TIME',
          value: '2017-09'
        }
      ]
    };
  }

  getUri = (baseUri, position) => {
    let params = '';
    this.state[position].forEach(element => {
      params += '&' + element.key + '=' + element.value;
    });
    return baseUri + params;
  };

  timeChanged = (value, position) => {
    switch (position) {
    case 'right':
      this.setState({
        right: [
          {
            key: 'TIME',
            value: value
          }
        ]
      });
      break;
    case 'left':
      this.setState({
        left: [
          {
            key: 'TIME',
            value: value
          }
        ]
      });
      break;
    }

    return true;
  };

  onChangeWidth = width => {
    this.setState({
      width: width
    });
    this.props.forceUpdateMap();
  };

  onPreCompose = (event, position) => {
    var ctx = event.context;
    var width = this.state.width ? ctx.canvas.width - this.state.width : ctx.canvas.width * 0.5;
    ctx.save();
    ctx.beginPath();
    if (position === 'left') {
      ctx.rect(0, 0, width, ctx.canvas.height);
    } else {
      ctx.rect(width, 0, ctx.canvas.width, ctx.canvas.height);
    }
    ctx.clip();
  };

  onPostCompose = event => {
    var ctx = event.context;
    ctx.restore();
  };

  render () {
    let baseUri =
      'https://kart.barentswatch.net/proxies/xWmsProxy.ashx?uuid=1b41307d-06e6-4c7b-917c-95c265ec8d62&key=20180418104819';
    return (
      <div>
        <WmsLayer
          key='europakart'
          name='Europakart'
          id='europakart'
          projCode='EPSG:3575'
          layerName='bakgrunnskart_havarealverktoey_3575'
          version='1.3.0'
          uri='https://map1.barentswatch.net/mapcache/mapcache.ashx?'
        />
        <WmsLayer
          key='swipe1'
          name='swipe1'
          id='swipe1'
          projCode='EPSG:3575'
          layerName='fishingquantity_tonn_wmstime'
          version='1.3.0'
          uri={this.getUri(baseUri, 'left')}
          singleTile
          onPreCompose={event => this.onPreCompose(event, 'left')}
          onPostCompose={this.onPostCompose}
        />
        <WmsLayer
          key='swipe2'
          name='swipe2'
          id='swipe2'
          projCode='EPSG:3575'
          layerName='fishingquantity_tonn_wmstime'
          version='1.3.0'
          uri={this.getUri(baseUri, 'right')}
          singleTile
          onPreCompose={event => this.onPreCompose(event, 'right')}
          onPostCompose={this.onPostCompose}
        />
        <Splitter key='splitter' onChange={this.onChangeWidth} />
        <TimePicker
          className='left'
          min='2015-01'
          max='2018-07'
          value='2017-09'
          onChange={value => this.timeChanged(value.value, 'left')}
        />
        <TimePicker
          className='right'
          min='2015-01'
          max='2018-07'
          value='2017-01'
          onChange={value => this.timeChanged(value.value, 'right')}
        />
      </div>
    );
  }
}

Layers.propTypes = {
  forceUpdateMap: PropTypes.func.isRequired
};

export default provideMapState(Layers);



// WEBPACK FOOTER //
// ./src/component/Layers.js